import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import QuoteForm from '../components/QuoteForm';

const QuotePage: React.FC = () => {
  const location = useLocation();
  const [selectedService, setSelectedService] = useState('');
  
  useEffect(() => {
    // Check for service parameter in the URL
    const params = new URLSearchParams(location.search);
    const service = params.get('service');
    if (service) {
      setSelectedService(service);
    }
  }, [location]);

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative bg-purple-900 py-20">
        <div 
          className="absolute inset-0 z-0 opacity-30" 
          style={{
            backgroundImage: 'url("https://images.pexels.com/photos/261376/pexels-photo-261376.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Get Your Free Quote</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Fill out the form below to receive a customized quote for your pool care needs.
          </p>
        </div>
      </section>

      {/* Quote Form Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="md:col-span-2">
                <QuoteForm />
              </div>
              
              <div>
                <div className="bg-white rounded-lg shadow-xl p-6 sticky top-24">
                  <h3 className="text-xl font-bold text-purple-900 mb-4">Why Choose Us?</h3>
                  
                  <ul className="space-y-4 mb-6">
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">First month of service FREE for new customers</span>
                    </li>
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">Licensed and insured professionals</span>
                    </li>
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">Reliable, on-time service</span>
                    </li>
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">High-quality chemicals and equipment</span>
                    </li>
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">Flexible scheduling options</span>
                    </li>
                    <li className="flex items-start">
                      <span className="h-5 w-5 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold mr-2 mt-0.5">✓</span>
                      <span className="text-gray-700">No long-term contracts required</span>
                    </li>
                  </ul>
                  
                  <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4">
                    <p className="text-gray-700">
                      <span className="font-semibold">Quick Response:</span> We typically respond to quote requests within 24 hours.
                    </p>
                  </div>
                  
                  <img 
                    src="https://images.pexels.com/photos/261410/pexels-photo-261410.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" 
                    alt="Clean pool"
                    className="w-full h-auto rounded-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuotePage;